var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXmark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0104 2.54762C15.4411 2.11692 15.4411 1.42047 15.0104 0.994354C14.5797 0.568237 13.8832 0.563655 13.4571 0.994354L8.00466 6.44682L2.54762 0.989772C2.11692 0.559073 1.42047 0.559073 0.994354 0.989772C0.568237 1.42047 0.563655 2.11692 0.994354 2.54304L6.44682 7.9955L0.989772 13.4525C0.559073 13.8832 0.559073 14.5797 0.989772 15.0058C1.42047 15.4319 2.11692 15.4365 2.54304 15.0058L7.9955 9.55334L13.4525 15.0104C13.8832 15.4411 14.5797 15.4411 15.0058 15.0104C15.4319 14.5797 15.4365 13.8832 15.0058 13.4571L9.55334 8.00466L15.0104 2.54762Z",
    fill: "#2E3285"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXmark);
export default __webpack_public_path__ + "static/media/xmark.c05ba77b8c997154a833a85fd9cbcf88.svg";
export { ForwardRef as ReactComponent };